import script from "./mobile-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./mobile-menu.vue?vue&type=script&setup=true&lang=js"

import "./mobile-menu.vue?vue&type=style&index=0&id=e4dccb98&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4dccb98"]])

export default __exports__